// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; import './autoload/lazyload.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';
import Player from '@vimeo/player';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function() {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function() {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Change data scroll in/out functions
 */
function dataOut($element) {
  $element.find('[data-scroll]').each(function() {
    $(this).attr('data-scroll', 'out');
  });
}

function dataIn($element) {
  $element.find('[data-scroll]').each(function() {
    $(this).attr('data-scroll', 'in');
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function() {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    offset: 0,
    threshold: 0.3,
    once: true,
    onShown: function(element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function(i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function() {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function() {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function() {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function() {
    setTimeout(function() {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  /**
   * Hide animated elements in header and home slider
   */
  dataOut($('.header'));
  dataOut($('.home-slider'));

  let activePlayers = [],
    $videos = $('.js-video');

  $videos.each(function() {
    let playerId = $(this).attr('id');
    // options = {
    //   background: true,
    //   controls: false,
    //   muted: true,
    //   title: false,
    //   byline: false,
    // };
    activePlayers[playerId] = new Player($(this).find('iframe'));
  });

  let playing = false;
  $videos.on('click', function() {
    if (playing == false) {
      $(this)
        .closest('.video-carousel__container')
        .addClass('playing');
      activePlayers[$(this).attr('id')].play();
      playing = true;
    } else if (playing == true) {
      $(this)
        .closest('.video-carousel__container')
        .removeClass('playing');
      activePlayers[$(this).attr('id')].pause();
      playing = false;
    }
  });

  /**
   * Video Carousel functions
   */
  let $videoCarousel = $('.js-video-carousel');

  $videoCarousel.on('beforeChange', function(event, slick, currentSlide) {
    activePlayers[
      slick.$slides
        .eq(currentSlide)
        .find('.js-video')
        .attr('id')
    ].pause();
    slick.$slides
      .eq(currentSlide)
      .find('.video-carousel__container')
      .removeClass('playing');
  });

  $videoCarousel.slick({
    cssEase: 'cubic-bezier(0.755, 0.155, 0.275, 0.865)',
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    dots: true,
  });

  /**
   * Init Stories Carousel
   */
  let $storiesCarousel = $('.js-story-carousel');
  if ($storiesCarousel.length) {
    $storiesCarousel.slick({
      cssEase: 'cubic-bezier(0.755, 0.155, 0.275, 0.865)',
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      speed: 1250,
    });
  }

  /**
   * Init Images slideshow
   */
  let $slideShow = $('.js-slideshow');
  if ($slideShow.length) {
    $slideShow.each(function() {
      $(this).slick({
        cssEase: 'cubic-bezier(0.755, 0.155, 0.275, 0.865)',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        speed: 750,
        rows: false,
      });
    });
  }

  /**
   * Init Modal Slider
   */
  $('[data-fancybox]').fancybox({
    autoSize: true,
    afterShow: function(instance) {
      let $modalSlider = $(instance.$refs.container[0]).find(
        '.js-modal-slider'
      );
      if ($modalSlider.length) {
        $modalSlider.each(function() {
          $(this).slick({
            cssEase: 'cubic-bezier(0.755, 0.155, 0.275, 0.865)',
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            speed: 500,
            rows: 0, // Prevent generating extra markup
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 3,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          });
        });
      }
    },
  });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function() {
  // jQuery code goes here

  /**
   * Show animated elements in header and home slider
   */
  dataIn($('.header'));
  dataIn($('.home-slider'));

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function() {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function() {
  // jQuery code goes here
});
